export default __webpack_public_path__ + "static/media/VIP_yellow.48f15be3.png";